import { render, staticRenderFns } from "./IconFiles.vue?vue&type=template&id=271ef474"
import script from "./IconFiles.vue?vue&type=script&lang=js"
export * from "./IconFiles.vue?vue&type=script&lang=js"
import style0 from "./IconFiles.vue?vue&type=style&index=0&id=271ef474&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports